
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import LazyImage from "@src/components/LazyImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import { murakamiMasanori } from "@src/constants/authors";
import {
  harajukuYogoroMenuYogoroMenuTopImage,
  harajukuYogoroMenuYogoroMenuImage,
} from "@src/constants/images";
import { meta as yogoroPageMeta } from "./yogoro.mdx";
export const meta = {
  path: "/media/harajuku/yogoro_menu",
  title: "【貴重情報】ヨゴロウのメニューと行列情報を公開",
  description: "原宿カレーの名店「ヨゴロウ」のメニュー、行列情報についてお伝えします。定番のメニューから1日限定数食しかないメニューまで、写真付きでご紹介させていただきます。また、実測値に基づいて行列の待ち時間をご紹介させていただきます。",
  topImg: harajukuYogoroMenuYogoroMenuTopImage,
  author: murakamiMasanori,
  tags: ["カレー", "有名店", "行列店", "原宿", "人気店", "まとめ記事", "食べログ高評価", "メニュー詳細"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿カレーの名店「ヨゴロウ」のメニュー、行列情報についてお伝えします。`}</p>
    <p>{`定番のメニューは何？ほうれん草カレー以外にもあるの？1 日限定数食しかないメニューは？といったヨゴロウならではの悩みが解消されます。`}</p>
    <p>{`また、どれくらいの待ち時間？という疑問に対しては、実測値に基づいて行列の待ち時間をご紹介させていただきますので、ヨゴロウに行く際には是非チェックしてみてください！`}</p>
    <h2>{`原宿で人気のカレー店「ヨゴロウ」`}</h2>
    <InstaImage postId="CAepDemFADo" mdxType="InstaImage" />
    <p>{`休日だけでなく平日でもオープン前から行列ができている原宿で人気のお店。
食べログの評価は 3.8 を超え、カレー百名店にも選出されています。`}</p>
    <p>{`そんなヨゴロウについて本日はご紹介しますが、メインは「どんなカレーのメニューがあるのか」について写真付きでご紹介させていただければと思います。
１日限定のカレーを提供していたりするので、ぜひチェックしてみてください！`}</p>
    <h3>{`看板も出さない隠れ家的な雰囲気`}</h3>
    <InstaImage postId="CARgqXiAnC1" mdxType="InstaImage" />
    <p>{`ヨゴロウの特徴の１つが看板を出していない隠れ家的なお店であること。通りに面したレンガの建物の一階に位置するヨゴロウは、店舗の外観を知らない方だと一回で見つけることはできないのではないかと思います。
ほうれん草カレーが有名なのですが、お店の外からほうれん草の香りがするレンガの建物が目印です。`}</p>
    <h3>{`落ち着いた店内の雰囲気`}</h3>
    <InstaImage postId="B9tFVuvgNJL" mdxType="InstaImage" />
    <p>{`レンガの建物を少し降りて入り口を抜けると、木で内装された温かみのある店内になっています。落ち着いた雰囲気で食べるカレーは、特に休日だと異空間のようで素敵な時間になること間違いなしです！`}</p>
    <hr></hr>
    <h2>{`ヨゴロウのメニュー`}</h2>
    <p>{`ヨゴロウには数種類のメニューがありますが、スパイシーなトマトベースのカレー、クリーミーなーほうれん草カレー、挽肉をベースにしたカレーの 3 種類が基本のベースになっています。その中でも、１日数食限定メニューもあるので、ご紹介していきます！`}</p>
    <h3>{`【1 日 5 食】ポークほうれん草カレー`}</h3>
    <InstaImage postId="B9nqWl9g_V4" mdxType="InstaImage" />
    <p>{`幻のカレーと言われる限定 5 食のメニュー。とろとろになるまで煮込んだポークとホクホクの大根の巨大な塊が、ほうれんカレーの上にそのままトッピングされています。びっくりするほどスプーンがスッと入るポークは、脂の旨味がギュッと詰まっていてほうれん草と相性がバッチリ。カレーとポークの脂を、大根が中和してくれるので、胃もたれもせずサクサク食べれてしまうのが特徴的なメニュー。`}</p>
    <h3>{`チキンほうれん草カレー`}</h3>
    <InstaImage postId="CB-Q2o1Db54" mdxType="InstaImage" />
    <p>{`ヨゴロウの定番で 1 番人気のメニューになります。お店の外まで香るほうれん草の香りの正体はこちらのカレーで、チキンは注文を受けてから炭火で焼いた香ばしい香り。サフランライスと一緒に食べるカレーは普段は食べたことのない独特な味です。`}</p>
    <h3>{`チキントマトカレー`}</h3>
    <InstaImage postId="CCNn_kEAY4a" mdxType="InstaImage" />
    <p>{`スパイスとトマトをベースにつくるチキントマトカレーも常連の方やリピーターの方に人気のメニューです。チキンは同じように香ばしく味付けがされており、サフランライスとの相性がバッチリのトマトの風味を楽しめるカレーメニューになっています。`}</p>
    <h3>{`ビンディキーマ`}</h3>
    <InstaImage postId="CCbCEmxJRkx" mdxType="InstaImage" />
    <p>{`挽肉で作るビンディキーマカレーには、なんとオクラが入っています。「どんな味なんだろう」と思って不安になる方もいるのですが、食べた後には「注文してよかった」となるカレーの人気メニュー。
スパイスの風味をオクラがアクセントになってまとまりのある味になっています。`}</p>
    <h3>{`トッピング`}</h3>
    <p>{`チーズと半熟卵が 100 円でトッピングがメニューの全てにできるようになっています。
写真にするとこのような感じになります。`}</p>
    <InstaImage postId="B72W7FigAfc" mdxType="InstaImage" />
    <p>{`初回、リピートにかかわらず、気になった方は注文するカレーに是非トッピングしてみてください。`}</p>
    <hr></hr>
    <h2>{`行列情報`}</h2>
    <LazyImage img={harajukuYogoroMenuYogoroMenuImage} mdxType="LazyImage" />
    <p>{`平日でもオープン前から行列ができているので、行列の時間がわからない中で行くのに少し気が引ける方に、目安の時間帯をご紹介します。
休日だと 10 人以上の待ち人数が平均的ですが、思ったよりも回転率が速く、30 分以内に入店できることが多いです。
なので、30 分以内に入れることを目安に、お越しいただければと思います。`}</p>
    <hr></hr>
    <p>{`ヨゴロウについてもっと詳しくしたい方はこちら！`}</p>
    <LinkWithThumbnail meta={yogoroPageMeta} mdxType="LinkWithThumbnail" />
    <ShopInfoBox shopId="bree0da23akg00eoptlg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿の人気カレー店「ヨゴロウ」の特徴、メニュー、行列情報についてご紹介してきました。
ほうれん草カレーが有名ですが、トマトカレーやビンディキーマなどのメニューもあるので、その日の気分に合わせてカレーを選んでいただければと思います！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;